<template>
  <div id="contenedor-eliminar-contrato-estimacion">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Estimación </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la estimación? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrarEliminar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarEstimacion"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixEstimaciones from './mixEstimaciones';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarEstimacionContrato',
  mixins: [mixEstimaciones],
  props: {
    contratoEstimacionEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrarEliminar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
